import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteColor } from '../Api'

export default generateApiAction({
  baseType: Types.COLORS.DELETE,
  api: deleteColor,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/colors/DeleteAction.js